/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Syphon = require('backbone.syphon');

var tmplDepProgressReportFormView = require('../templates/DepProgressReportFormView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplDepProgressReportFormView,

  className: 'dep-progress-report-form-view',

  ui: {
    dueDate: '.due-date',
    submissionDate: '.submission-date',
    acknowledgmentDate: '.acknowledgment-date'
  },

  onBeforeShow: function() {
    Syphon.deserialize(this, this.model.get('progressReport'));

    this.ui.dueDate.datepicker();
    this.ui.submissionDate.datepicker();
    this.ui.acknowledgmentDate.datepicker();
  },

  getFormData: function() {
    var formData = Syphon.serialize(this);
    formData.entityId = this.model.get('entityId');
    formData.enforcementId = this.model.get('enforcementId');
    formData.progressReportId = this.model.get('progressReportId');
    return formData;
  }
});
